import axios from 'axios';
export default () => {
  const promise = new Promise((resolve, reject) => {
    axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}tags?type=b2b`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
